import { StepStatus } from '@common/enums';
import type { Color, IGraphSizes, IPosition } from '../helpers';
import type { IProcessWorkflowStep } from '../WorkflowGraph';
import { Ellipse } from './Ellipse';
import { StepLabel } from './StepLabel';

interface IStartStepProps {
    graphSizes: IGraphSizes;
    label: string;
    onMouseOut: () => void;
    onMouseOver: () => void;
    position: IPosition;
    processWorkflowStep: IProcessWorkflowStep | undefined;
}

export function StartStep(props: IStartStepProps) {
    const { label, processWorkflowStep, position, graphSizes, onMouseOver, onMouseOut } = props;

    let borderColor: Color = 'purple';
    let fillColor: Color = 'white';
    const textColor: Color = 'black';
    if (processWorkflowStep && processWorkflowStep.status === StepStatus.finished) {
        borderColor = 'green';
        fillColor = 'green';
    }

    return (
        <>
            <Ellipse
                borderColor={borderColor}
                borderWidth={4}
                fillColor={fillColor}
                graphSizes={graphSizes}
                position={position}
            />
            <StepLabel
                color={textColor}
                graphSizes={graphSizes}
                label={label}
                onMouseOut={onMouseOut}
                onMouseOver={onMouseOver}
                position={position}
            />
        </>
    );
}
